import { Controller } from "@hotwired/stimulus"
import ImageCompare from "image-compare-viewer"
export default class extends Controller {
  static targets = ["viewer"]
  connect() {
    const viewers = this.viewerTargets
    const viewer_options = {
      controlColor: "#707880",
      controlShadow: false,
      addCircle: true,
      addCircleBlur: true,
      showLabels: true,
      labelOptions: {
        before: 'Hunter Output',
        after: 'Clearbit Output',
        onHover: false
      },
    }
    viewers.forEach((element) => {
      new ImageCompare(element, viewer_options).mount()
    })
  }
}
